// @ts-nocheck
import productDetailsReducer, {
    BunzlPagesProductDetailsActions,
} from "@store/Framework/Store/Bunzl/Pages/ProductDetails/ProductDetailsReducer";
import { combineReducers, Dispatch } from "redux";

/* Store Custom Code - Start */
import bunzlExtraAccountSettingsReducer, {
    BunzlExtraAccountSettingsActions,
} from "@store/Framework/Store/Bunzl/Pages/AccountSettings/BunzlExtraAccountSettingsReducer";
import bulkListReducer, { BulkListActions } from "@store/Framework/Store/Bunzl/Pages/BulkLists/BulkListReducer";
import buyingListReducer, { BuyingListActions } from "@store/Framework/Store/Bunzl/Pages/BuyingList/BuyingListReducer";
import authorizedPickUpPersonReducer, {
    AuthorizedPickUpPersonActions,
} from "@store/Framework/Store/Bunzl/Pages/CheckoutReviewAndSubmit/AuthorizedPickUpPersonReducer";
import addToListReducer, { AddToListActions } from "@store/Framework/Store/Bunzl/Pages/Header/AddToListReducer";
import dynamicSearchWidthReducer, {
    DynamicSearchWidthActions,
} from "@store/Framework/Store/Bunzl/Pages/Header/DynamicSearchWidthReducer";
import categoryReducer, {
    MyListDetailsCategoryActions,
} from "@store/Framework/Store/Bunzl/Pages/MyListDetails/MyListDetailsCategoryReducer";
import productDetailsZoomReducer, {
    ProductDetailsZoomActions,
} from "@store/Framework/Store/Bunzl/Pages/ProductDetailsZoom/ProductDetailsZoomReducer";
import ReportAPIReducer, {
    InvoiceDetailActions,
    InvoiceSummaryActions,
    ReportAPIactions,
} from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportApi/ReportAPIReducer";
import reportOrderFrequencyReducer, {
    BunzlPagesReportOrderHistoryActions,
} from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencyReducer";
import signatureReducer, { SignatureActions } from "@store/Framework/Store/Bunzl/Pages/Signature/SignatureReducer";
import StepFormReducer, { StepFormActions } from "@store/Framework/Store/Bunzl/Pages/StepForm/StepFormReducer";
import AccountBalanceReducer, {
    AccountBalanceActions,
} from "@store/Framework/Store/Pages/AccountBalance/AccountBalanceReducer";
import changeCustomerReducer, {
    ChangeCustomerActions,
} from "@store/Framework/Store/Pages/ChangeCustomer/ChangeCustomerReducer";
import PromotionTreeReducer, {
    PromotionTreeActions,
} from "@store/Framework/Store/Pages/PromotionTree/PromotionTreeReducer";
import { useDispatch } from "react-redux";

const { reportAPIReducer, invoiceSummaryReducer, invoiceDetailReducer } = ReportAPIReducer;
/* Store Custom Code - End */

const pagesReducers = {
    productDetails: productDetailsReducer,
    // Store Custom Code
    buyingList: buyingListReducer,
    ReportAPI: reportAPIReducer,
    invoiceDetail: invoiceDetailReducer,
    invoiceSummaryReportData: invoiceSummaryReducer,
    reportOrderFrequency: reportOrderFrequencyReducer,
    Signature: signatureReducer,
    promotionTree: PromotionTreeReducer,
    bulkLists: bulkListReducer,
    stepForm: StepFormReducer,
    myListDetailsCategory: categoryReducer,
    addToList: addToListReducer,
    dynamicSearchWidth: dynamicSearchWidthReducer,
    productDetailsZoom: productDetailsZoomReducer,
    accountBalance: AccountBalanceReducer,
    changeCustomer: changeCustomerReducer,
    accountSettings: bunzlExtraAccountSettingsReducer,
    checkoutReviewAndSubmit: authorizedPickUpPersonReducer,
};

/* Store Custom Code - Start */
export type BunzlPagesActions =
    | ProductDetailsZoomActions
    | StepFormActions
    | BunzlPagesProductDetailsActions
    | BuyingListActions
    | InvoiceDetailActions
    | ReportAPIactions
    | InvoiceSummaryActions
    | BunzlPagesReportOrderHistoryActions
    | SignatureActions
    | PromotionTreeActions
    | BulkListActions
    | MyListDetailsCategoryActions
    | AccountBalanceActions
    | AddToListActions
    | DynamicSearchWidthActions
    | ChangeCustomerActions
    | BunzlExtraAccountSettingsActions
    | AuthorizedPickUpPersonActions;

/* Store Custom Code - End */
export default combineReducers(pagesReducers);
